<template>
  <div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.id_number")
        }}</label>
        <input
          id="id_number"
          type="text"
          v-model="localData.id_number"
          placeholder="ROXXX"
          v-on:keydown="onlyCompanyIdentification_number"
          :class="{ 'field-error': $v.localData.id_number.$error }"
          class="form-control upper"
        />
      </div>
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("common.nr_reg")
        }}</label>
        <input
          v-model="localData.nr_reg"
          class="form-control upper"
          placeholder="JXX/XXX/YYYY"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.intra_community_vat_code")
        }}</label>
        <input
          v-model="localData.intra_community_vat_code"
          class="form-control upper"
          placeholder=""
        />
      </div>
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.insured_code")
        }}</label>
        <input
          v-model="localData.insured_code"
          class="form-control upper"
          placeholder=""
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.farmer_authorization_code")
        }}</label>
        <input
          v-model="localData.farmer_authorization_code"
          class="form-control upper"
          placeholder=""
        />
      </div>
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.statistical_code")
        }}</label>
        <input
          v-model="localData.statistical_code"
          class="form-control upper"
          placeholder=""
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.excise_authorization_no")
        }}</label>
        <input
          v-model="localData.excise_authorization_no"
          class="form-control upper"
          placeholder=""
        />
      </div>
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t("stock_management.partners.tax_warehouse_identification_code")
        }}</label>
        <input
          v-model="localData.tax_warehouse_identification_code"
          class="form-control upper"
          placeholder=""
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-8 col-lg-4 text-left">
        <label class="control-label">{{
          $t(
            "stock_management.partners.agricultural_cooperative_registration_no"
          )
        }}</label>
        <input
          v-model="localData.agricultural_cooperative_registration_no"
          class="form-control upper"
          placeholder=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import required from "vuelidate/lib/validators/required";
import { mapActions, mapGetters } from "vuex";
import {
  only_company_identification_number,
} from "~/helpers/common";

export default {
  name: "PartnerIdentificationData",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.data }, // Create a local copy of data
    };
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    ...mapActions({}),
    onlyCompanyIdentification_number(event) {
      return only_company_identification_number(event);
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      return true;
    },
    updateData(newData) {
      if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        console.log("updateData step 2 ", newData);
        this.localData = { ...newData }; // Update localData with new data
      }
    },
  },
  mounted() {},
  watch: {
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("update-partner-data", newData, 2); // Emit updated data to parent
      },
    },
  },
  validations() {
    return {
      localData: {
        id_number: {
          required,
        },
      },
    };
  },
};
</script>
